import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'documents-lists',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'documents-lists',
            component: () => import('../pages/DocumentsListsPage.vue')
          },
          {
            path: 'create',
            name: 'documents-lists.create',
            component: () =>
              import('../pages/DocumentsListsCreatePage.vue'),
            props: route => ({
              personId: Number(route.params.personId)
            })
          },
          {
            path: ':id',
            name: 'documents-lists.show',
            component: () =>
              import('../pages/DocumentsListsShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
